module.exports = __webpack_public_path__ + "media/images/mouthpieces-9b35c69483a3aa3c9cf6f1aa42ce8d74.jpg";